export default "__VITE_ASSET__zXr0pHUM__"